// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const embeddedUrlApi = {
  fetchEmbeddedUrlByPage: (page: string) => new RestClientAuthenticated(`${turanBaseURL()}/embedded-urls`, 'GET')
    .addParam('page', page)
    .execute(),
};

export default embeddedUrlApi;
